import _ from 'lodash';
import React from 'react';

import {
  Box,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@mui/material';
import {
  useMemo,
  useState
} from 'react';

import { modalUtil } from 'iron-forge-react-modules';
import * as ds from './dataService';
import * as ImportInventoryItemsModal from './ImportInventoryItemsModal/ImportInventoryItemsModal';
import * as ImportNetSuiteDepartmentsModal from './ImportNetSuiteDepartmentsModal/ImportNetSuiteDepartmentsModal';
import * as ImportNetSuiteEmployeesModal from './ImportNetSuiteEmployeesModal/ImportNetSuiteEmployeesModal';
import * as ImportNetSuiteShipItemsModal from './ImportNetSuiteShipItemsModal/ImportNetSuiteShipItemsModal';
import * as ImportNetSuiteSubsidiariesModal from './ImportNetSuiteSubsidiariesModal/ImportNetSuiteSubsidiariesModal';
import * as ImportPaymentMethodsModal from './ImportPaymentMethodsModal/ImportPaymentMethodsModal';
import * as ImportNetSuiteInventoryLocationsModal from './ImportNetSuiteInventoryLocationsModal/ImportInventoryLocationsModal';



type Keys = keyof ReturnType<typeof ds.useQuery>['data'];

export const FC: React.FC = () => {
  const queryTuple = ds.useQuery();
  const [recordType, setRecordType] = useState<Keys>('shipItems');

  const keys = useMemo(
    () => _.keys(queryTuple.data).map(d => d as Keys),
    [queryTuple]);

  const {
    modalType2IsOpen,
    setModalIsOpen
  } = modalUtil.useModalTrackers([
    'importNetSuiteShipItemsModal',
    'importNetSuiteDepartmentsModal',
    'importNetSuiteSubsidiariesModal',
    'importNetSuiteEmployeesModal',
    'importInventoryItemsModal',
    'importPaymentMethodsModal',
    'importNetSuiteInventoryLocationsModal'
  ]);

  const TopRightContainer = styled(Box)(() => ({
    position: 'relative',
    top: '-15px',
    right: 0,
    marginRight: '10px'
  }));

  return (
    <Stack direction="row">
      <List sx={{ minWidth: 256 }}>
        {keys.map(key => (
          <ListItem key={key}>
            <ListItemButton
              selected={recordType === key}
              onClick={() => setRecordType(key)}>
              <ListItemText
                primary={_.startCase(key)}
                secondary={queryTuple.data[key].length + " items"} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      <Table
        size="small">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>NetSuite Internal ID</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {queryTuple.data[recordType].map(row => (
            <TableRow key={row.id}>
              <TableCell>{row.name}</TableCell>
              <TableCell>{row.internalId}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <TopRightContainer>
        <Button
          style={{ whiteSpace: 'nowrap' }}
          variant="contained"
          onClick={() => {
            switch (recordType) {
            case 'shipItems':
              setModalIsOpen('importNetSuiteShipItemsModal', true);
              break;
            case 'departments':
              setModalIsOpen('importNetSuiteDepartmentsModal', true);
              break;
            case 'subsidiaries':
              setModalIsOpen('importNetSuiteSubsidiariesModal', true);
              break;
            case 'employees':
              setModalIsOpen('importNetSuiteEmployeesModal', true);
              break;
            case 'inventoryItems':
              setModalIsOpen('importInventoryItemsModal', true);
              break;
            case 'paymentMethods':
              setModalIsOpen('importPaymentMethodsModal', true);
              break;
            case 'inventoryLocations':
              setModalIsOpen('importNetSuiteInventoryLocationsModal', true);
              break;
            default:
              break;
            }
          }}>
          Import {_.startCase(recordType)} CSV
        </Button>

        {modalType2IsOpen.importNetSuiteShipItemsModal && (
          <ImportNetSuiteShipItemsModal.FC
            onAccept={() => setModalIsOpen('importNetSuiteShipItemsModal', false)}
            onCancel={() => setModalIsOpen('importNetSuiteShipItemsModal', false)} />
        )}

        {modalType2IsOpen.importNetSuiteDepartmentsModal && (
          <ImportNetSuiteDepartmentsModal.FC
            onAccept={() => setModalIsOpen('importNetSuiteDepartmentsModal', false)}
            onCancel={() => setModalIsOpen('importNetSuiteDepartmentsModal', false)} />
        )}

        {modalType2IsOpen.importNetSuiteSubsidiariesModal && (
          <ImportNetSuiteSubsidiariesModal.FC
            onAccept={() => setModalIsOpen('importNetSuiteSubsidiariesModal', false)}
            onCancel={() => setModalIsOpen('importNetSuiteSubsidiariesModal', false)} />
        )}

        {modalType2IsOpen.importNetSuiteEmployeesModal && (
          <ImportNetSuiteEmployeesModal.FC
            onAccept={() => setModalIsOpen('importNetSuiteEmployeesModal', false)}
            onCancel={() => setModalIsOpen('importNetSuiteEmployeesModal', false)} />
        )}

        {modalType2IsOpen.importInventoryItemsModal && (
          <ImportInventoryItemsModal.FC
            onAccept={() => setModalIsOpen('importInventoryItemsModal', false)}
            onCancel={() => setModalIsOpen('importInventoryItemsModal', false)} />
        )}

        {modalType2IsOpen.importPaymentMethodsModal && (
          <ImportPaymentMethodsModal.FC
            onAccept={() => setModalIsOpen('importPaymentMethodsModal', false)}
            onCancel={() => setModalIsOpen('importPaymentMethodsModal', false)} />
        )}

        {modalType2IsOpen.importNetSuiteInventoryLocationsModal && (
          <ImportNetSuiteInventoryLocationsModal.FC
            onAccept={() => setModalIsOpen('importNetSuiteInventoryLocationsModal', false)}
            onCancel={() => setModalIsOpen('importNetSuiteInventoryLocationsModal', false)} />
        )}

      </TopRightContainer>
    </Stack>
  );
};
